<template>
  <div class="pb100 searchcontainer">
    <div class="container bgfff pb20">
      <div class="topbox">
        <el-form ref="form">
          <el-form-item prop="title" class="itembox">
            <el-input v-model="formdata.title" placeholder="请输入关键字"></el-input>
            <el-button type="primary" @click="searchKey"><i class="el-icon-search"></i>搜索</el-button>
          </el-form-item>
          <el-form-item prop="moduleType">
            <el-radio-group v-model="formdata.moduleType"  @change="selectType">
              <el-radio label="all">全部</el-radio>
              <el-radio label="info">资讯</el-radio>
              <el-radio label="activity">活动</el-radio>
              <el-radio label="venue">场馆</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <ul class="ul1" v-if="dataList && dataList.length > 0">
        <li v-for="(item, index) in dataList" :key="index">
          <router-link :to="'/' + item.type + 'detail?columnId=' + item.menuId + '&id=' + item.entityId">
            <span>【{{ item.typename }}】</span>
            <h2 v-html="item.title"></h2>
          </router-link>
        </li>
      </ul>
      <nodata v-if="dataList && dataList.length === 0"/>
      <el-pagination
        v-if="dataList && dataList.length > 0"
        @current-change="handleCurrentChange"
        :page-size="params.limit"
        :pager-count="5"
        :current-page.sync="params.currentPage"
        layout="prev, pager, next"
        :total="listTotal"
        class="pagemodel1">
      </el-pagination>
    </div>
    <go-top></go-top>
  </div>
</template>

<script>
import { getsearch } from '@/api/user/index'
import nodata from '@/components/nodata/index'
import { scrollAnimation } from '@/utils/index'
import goTop from '@/components/gotop/index'
export default {
  name: 'search',
  meta: {
    showHeader: true
  },
  components: {
    nodata,
    goTop
  },
  data () {
    return {
      formdata: {
        title: '',
        moduleType: 'all'
      },
      params: {
        currentPage: 1,
        page: 1,
        limit: 10,
        title: '',
        moduleType: '',
        fid: this.$cookie.get('culturalCloud_fid')
      },
      List: {
        'status': 200,
        'data': {
          'total': 4,
          'rows': [
            {
              'id': '613998',
              'entityId': 7,
              'menuId': 6176,
              'title': '确保全年粮食产量保持在一点三万亿斤以上',
              'moduleType': 'info',
              'fid': '12117'
            }, {
              'id': '613998',
              'entityId': 15,
              'menuId': 6176,
              'title': '《向往5》我是真的感受到了黄磊的无奈，对这个节目的失望',
              'moduleType': 'info',
              'fid': '12117'
            }, {
              'id': '613998',
              'entityId': 11,
              'menuId': 6196,
              'title': '“青春芒果节 打卡长沙城”活动正式拉开帷幕，这个夏天长沙喊你来玩',
              'moduleType': 'activity',
              'fid': '12117'
            }, {
              'id': '613998',
              'entityId': 11,
              'menuId': 6196,
              'title': '夜游青龙镇，梦幻戏剧节 ” 活动',
              'moduleType': 'venue',
              'fid': '12117'
            }, {
              'id': '613998',
              'entityId': 7,
              'menuId': 6176,
              'title': '确保全年粮食产量保持在一点三万亿斤以上',
              'moduleType': 'info',
              'fid': '12117'
            }, {
              'id': '613998',
              'entityId': 15,
              'menuId': 6176,
              'title': '《向往5》我是真的感受到了黄磊的无奈，对这个节目的失望',
              'moduleType': 'info',
              'fid': '12117'
            }, {
              'id': '613998',
              'entityId': 11,
              'menuId': 6196,
              'title': '“青春芒果节 打卡长沙城”活动正式拉开帷幕，这个夏天长沙喊你来玩',
              'moduleType': 'activity',
              'fid': '12117'
            }, {
              'id': '613998',
              'entityId': 11,
              'menuId': 6196,
              'title': '夜游青龙镇，梦幻戏剧节 ” 活动',
              'moduleType': 'venue',
              'fid': '12117'
            }, {
              'id': '613998',
              'entityId': 7,
              'menuId': 6176,
              'title': '确保全年粮食产量保持在一点三万亿斤以上',
              'moduleType': 'info',
              'fid': '12117'
            }, {
              'id': '613998',
              'entityId': 15,
              'menuId': 6176,
              'title': '《向往5》我是真的感受到了黄磊的无奈，对这个节目的失望',
              'moduleType': 'info',
              'fid': '12117'
            }, {
              'id': '613998',
              'entityId': 11,
              'menuId': 6196,
              'title': '“青春芒果节 打卡长沙城”活动正式拉开帷幕，这个夏天长沙喊你来玩',
              'moduleType': 'activity',
              'fid': '12117'
            }, {
              'id': '613998',
              'entityId': 11,
              'menuId': 6196,
              'title': '夜游青龙镇，梦幻戏剧节 ” 活动',
              'moduleType': 'venue',
              'fid': '12117'
            }
          ]
        }
      },
      listTotal: 0,
      dataList: []
    }
  },
  mounted () {
    // this.getSearch()
    console.log(this.$route.query.key)
    // 判断是否从首页过来
    if (this.$route.query.key !== undefined && this.$route.query.type !== undefined) {
      this.params.moduleType = this.$route.query.type
      this.params.title = this.$route.query.key
      this.formdata.title = this.$route.query.key
      this.getSearch()
    } else if (this.$route.query.key !== undefined) {
      this.params.title = this.$route.query.key
      this.formdata.title = this.$route.query.key
      this.getSearch()
    } else if (this.$route.query.type !== undefined) {
      this.params.moduleType = this.$route.query.type
      this.getSearch()
    } else {
      this.getSearch()
    }
    // this.List.data.rows.forEach(item => {
    //   if (item.moduleType === 'info') {
    //     item.typename = '资讯'
    //     item.type = 'information'
    //   }
    //   if (item.moduleType === 'venue') {
    //     item.typename = '场馆'
    //     item.type = 'venue'
    //   }
    //   if (item.moduleType === 'activity') {
    //     item.typename = '活动'
    //     item.type = 'appointment'
    //   }
    // })
    // this.dataList = this.List.data.rows
    // this.listTotal = this.List.data.total
    // console.log(this.listTotal)
  },
  methods: {
    searchKey () {
      this.params.page = 1
      this.params.title = this.formdata.title
      this.params.moduleType = this.formdata.moduleType
      this.getSearch()
    },
    selectType (val) {
      if (val === 'all') {
        this.params.moduleType = ''
      } else {
        this.params.moduleType = val
      }
    },
    getSearch () {
      if (this.params.moduleType === 'all') {
        this.params.moduleType = ''
      }
      getsearch(this.params).then(res => {
        console.log(res)
        if (res.data.status === 200) {
          res.data.data.rows.forEach(item => {
            if (item.moduleType === 'info') {
              item.typename = '资讯'
              item.type = 'information'
            }
            if (item.moduleType === 'venue') {
              item.typename = '场馆'
              item.type = 'venue'
            }
            if (item.moduleType === 'activity') {
              item.typename = '活动'
              item.type = 'appointment'
            }
          })
          this.dataList = res.data.data.rows
          this.listTotal = res.data.data.total
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    handleCurrentChange (val) {
      console.log(val)
      this.params.page = val
      const currentY = document.documentElement.scrollTop || document.body.scrollTop
      scrollAnimation(currentY, 0)
      this.getSearch()
    }
  }
}
</script>

<style lang="scss" scoped>
.searchcontainer{
  margin-top: 80px;
  .topbox{
    padding: 30px 30px 20px;
  }
  /deep/ .el-form{
    .el-form-item{
      margin: 0;
    }
    .itembox{
      margin: 0 0 10px 0;
      .el-form-item__content{
        width: 100%;
        .el-input,
        .el-button{
          display: block;
          float: left;
        }
        .el-input{
          width: 90%;
          .el-input__inner{
            border-radius: 0;
            border-right: none;
          }
        }
        .el-button{
          width: 10%;
          border-radius: 0;
          i{
            margin: 0 10px 0 0;
          }
        }
      }
    }
  }
  .ul1{
    padding: 20px;
    li{
      a{
        padding: 20px;
        border-bottom: solid 1px #f2f2f2;
        display: flex;
        position: relative;
        &:before{
          display: block;
          content: '';
          width: 8px;
          height: 8px;
          border-radius: 50%;
          border: solid 1px #d27b7b;
          position: absolute;
          left: 4px;
          top: 50%;
          margin-top: -6px;
        }
        span,h2{
          line-height: 36px;
          font-size: 16px;
        }
        span{
          width: 70px;
        }
        h2{
          flex: 1;
          min-width: 0;
        }
      }
      &:last-child{
        a{
          border-bottom: none;
        }
      }
      &:hover{
        transition: all 0.3s;
        a{
          h2{
            color: darkred;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/search/index.vue